import { render, staticRenderFns } from "./mvDelete.vue?vue&type=template&id=53663c74&scoped=true"
import script from "./mvDelete.vue?vue&type=script&lang=js"
export * from "./mvDelete.vue?vue&type=script&lang=js"
import style0 from "./mvDelete.vue?vue&type=style&index=0&id=53663c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53663c74",
  null
  
)

export default component.exports